import { Action } from '@ngrx/store';
import { CustomOrder } from '@order/const';
import { PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { PLACED_ORDER_PROCESS_ID } from '../checkout-state';

export const CHECKOUT_INIT = '[Checkout] Checkout init';
export const CHECKOUT_DESTROY = '[Checkout] Checkout destroy';

export const PLACE_ORDER = '[Checkout] Place Order';
export const PLACE_ORDER_FAIL = '[Checkout] Place Order Fail';
export const PLACE_ORDER_SUCCESS = '[Checkout] Place Order Success';
export const CLEAR_PLACE_ORDER = '[Checkout] Clear Place Order';

export const SET_ORDER_DETAILS = '[Checkout] Set Order Details';
export const RESET_ORDER_DETAILS = '[Checkout] Reset Order Details';

export class CheckoutInit implements Action {
  readonly type = CHECKOUT_INIT;
}

export class CheckoutDestroy implements Action {
  readonly type = CHECKOUT_DESTROY;
}

export class PlaceOrder extends StateUtils.EntityLoadAction {
  readonly type = PLACE_ORDER;

  constructor() {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class PlaceOrderFail extends StateUtils.EntityFailAction {
  readonly type = PLACE_ORDER_FAIL;

  constructor(public payload: any) {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID, payload);
  }
}

export class PlaceOrderSuccess extends StateUtils.EntitySuccessAction {
  readonly type = PLACE_ORDER_SUCCESS;

  constructor(
    public payload: CustomOrder,
    public extraData?: { cartId?: string },
  ) {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class ClearPlaceOrder extends StateUtils.EntityLoaderResetAction {
  readonly type = CLEAR_PLACE_ORDER;

  constructor() {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class SetOrderDetails implements Action {
  readonly type = SET_ORDER_DETAILS;

  constructor(public payload: CustomOrder) {}
}

export class ResetOrderDetails implements Action {
  readonly type = RESET_ORDER_DETAILS;
}

export type CheckoutActions =
  | CheckoutInit
  | CheckoutDestroy
  | PlaceOrder
  | PlaceOrderFail
  | PlaceOrderSuccess
  | SetOrderDetails;
